module.exports = __webpack_public_path__ + "static/FAQ-install2-d54cd3893a6f5fe6bf5853bbe0460719.jpg";